/**
 * @file components/shared/PaymentSuccessToast.jsx
 * @description Toast notification after returning from Stripe checkout.
 */

import { CheckCircle2, XCircle } from "lucide-react";

export function PaymentSuccessToast({ status, onDismiss }) {
  const isSuccess = status === "success";

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 animate-in slide-in-from-bottom-4 fade-in duration-300">
      <div
        className={`flex items-center gap-3 px-5 py-4 rounded-2xl border shadow-xl backdrop-blur-sm ${
          isSuccess
            ? "bg-emerald-500/10 border-emerald-500/20 text-emerald-400"
            : "bg-red-500/10 border-red-500/20 text-red-400"
        }`}
      >
        {isSuccess ? <CheckCircle2 size={20} /> : <XCircle size={20} />}
        <div>
          <p className="text-sm font-bold">
            {isSuccess ? "Welcome to Premium!" : "Payment was not completed"}
          </p>
          <p className="text-xs opacity-70">
            {isSuccess
              ? "All features are now unlocked. Enjoy!"
              : "No charge was made. Try again when ready."}
          </p>
        </div>
        <button
          onClick={onDismiss}
          className="ml-4 text-xs opacity-50 hover:opacity-100 transition-opacity"
        >
          ✕
        </button>
      </div>
    </div>
  );
}
